import Vue from 'vue'
import Router from 'vue-router'
import dataScreenView from "../views/dataScreenView";
import Level2 from "../views/Level2/index";
// import dataScreenView2 from "../views/dataScreenView2";
import Login from '../views/Login'
Vue.use(Router)
export const routes = [
    // {
    //     path: '/',
    //     component: Login
    // },
    {
        path: '/',
        component: dataScreenView
    },
    {
        path: '/dataScreenView',
        component: dataScreenView
    },
	{
	    path: '/dataScreenView/detail',
	    component: Level2
	},
    // {
    //     path: '/dataScreenView2',
    //     component: dataScreenView2
    // },
    {
        path: '/first',
        component: ()=>import('../views/first')
    }
]

const createRouter = () => new Router({
    routes
})

const router = createRouter()

export default router